import { render, staticRenderFns } from "./AdminHeader.vue?vue&type=template&id=165caafc&scoped=true&"
import script from "./AdminHeader.vue?vue&type=script&lang=ts&"
export * from "./AdminHeader.vue?vue&type=script&lang=ts&"
import style0 from "./AdminHeader.vue?vue&type=style&index=0&id=165caafc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165caafc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/business/yq-monitor-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('165caafc')) {
      api.createRecord('165caafc', component.options)
    } else {
      api.reload('165caafc', component.options)
    }
    module.hot.accept("./AdminHeader.vue?vue&type=template&id=165caafc&scoped=true&", function () {
      api.rerender('165caafc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/admin/components/AdminHeader.vue"
export default component.exports